import arvoreProdutosRoutes from '@/modules/produtos/arvore-produtos/routes'

export default [
  {
    path: '/v3/produtos',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [...arvoreProdutosRoutes],
  },
]
